/**
 * Product upsell block: checkboxes, variant selects, total price, add selected to cart
 */
(function () {
  function formatMoney(cents) {
    const format = (typeof theme !== 'undefined' && theme.settings && theme.settings.money_with_currency_format) ? theme.settings.money_with_currency_format : '${{amount}}';
    const value = (cents / 100).toFixed(2);
    return format.replace('{{amount}}', value).replace('{{amount_no_decimals}}', Math.round(cents / 100)).replace('{{amount_with_comma_separator}}', value.replace('.', ','));
  }

  function getSelectedTotal(container) {
    let total = 0;
    container.querySelectorAll('.product-upsell__row').forEach((row) => {
      const cb = row.querySelector('.product-upsell__checkbox');
      if (!cb || !cb.checked || cb.disabled) return;
      const price = parseInt(row.dataset.price || '0', 10);
      total += price;
    });
    return total;
  }

  function updateButton(container) {
    const total = getSelectedTotal(container);
    const button = container.querySelector('[data-add-upsell]');
    const totalEl = container.querySelector('[data-total-price]');
    if (totalEl) totalEl.textContent = formatMoney(total);
    if (button) {
      button.disabled = total === 0;
    }
  }

  function updateRowPrice(row) {
    const select = row.querySelector('.product-upsell__variant-select');
    if (!select) return;
    const opt = select.options[select.selectedIndex];
    const price = opt ? parseInt(opt.dataset.price || '0', 10) : 0;
    row.dataset.price = price;
    const priceEl = row.querySelector('.product-upsell__price');
    if (priceEl) priceEl.textContent = formatMoney(price);
  }

  if (!customElements.get('product-upsell')) {
    customElements.define('product-upsell', class ProductUpsell extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.button = this.querySelector('[data-add-upsell]');
        this.checkboxes = this.querySelectorAll('.product-upsell__checkbox');
        this.rows = this.querySelectorAll('.product-upsell__row');

        this.checkboxes.forEach((cb) => {
          cb.addEventListener('change', () => this.updateTotal());
        });

        this.querySelectorAll('.product-upsell__variant-select').forEach((select) => {
          select.addEventListener('change', (e) => {
            const row = select.closest('.product-upsell__row');
            if (!row) return;
            const opt = select.options[select.selectedIndex];
            const variantId = opt ? opt.value : '';
            row.dataset.variantId = variantId;
            if (opt) row.dataset.price = opt.dataset.price || '0';
            updateRowPrice(row);
            this.updateTotal();
          });
        });

        if (this.button) {
          this.button.addEventListener('click', (e) => this.addToCart(e));
        }

        this.updateTotal();
      }

      updateTotal() {
        updateButton(this);
      }

      addToCart(evt) {
        evt.preventDefault();
        const items = [];
        this.rows.forEach((row) => {
          const cb = row.querySelector('.product-upsell__checkbox');
          if (!cb || !cb.checked || cb.disabled) return;
          const variantId = row.dataset.variantId || cb.value;
          if (variantId) items.push({ id: variantId, quantity: 1 });
        });
        if (items.length === 0) return;

        const cartAddUrl = theme && theme.routes && theme.routes.cart_add_url;
        if (!cartAddUrl) {
          console.warn('Product upsell: theme.routes.cart_add_url not found');
          return;
        }

        this.button.disabled = true;
        this.button.classList.add('loading');
        const loadingOverlay = this.button.querySelector('.loading-overlay');
        if (loadingOverlay) loadingOverlay.hidden = false;

        const addOne = (index) => {
          if (index >= items.length) {
            this.button.disabled = false;
            this.button.classList.remove('loading');
            if (loadingOverlay) loadingOverlay.hidden = true;
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            const cartDrawer = document.getElementById('Cart-Drawer');
            if (cartDrawer && typeof cartDrawer.open === 'function') cartDrawer.open();
            return;
          }

          const formData = new FormData();
          formData.append('id', items[index].id);
          formData.append('quantity', String(items[index].quantity));

          fetch(cartAddUrl, {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
            body: formData
          })
            .then((res) => res.json())
            .then((data) => {
              if (data.status && data.status !== 200) {
                console.warn('Product upsell add error:', data.description || data.message);
              }
              addOne(index + 1);
            })
            .catch((err) => {
              console.error('Product upsell add error:', err);
              addOne(index + 1);
            });
        };

        addOne(0);
      }
    });
  }
})();
